export default {
  email: 'E-Mail',
  physicalAddress: 'Physische Adresse',
  webSiteUrl: 'Website-URL',
  loadingApplication: 'Laden der Anwendung',
  baseUrl: 'Basis-URL',
  redirectionUrl: 'Umleitungs-URL',
  prefix: 'Präfix',
  pickAApplicationColor: 'Wählen Sie eine Farbe für Ihre Anwendung',
  applicationSuccessfullyUpdated: 'Die Anwendung wurde erfolgreich aktualisiert',
  apiKeyCopied: 'Api-Schlüssel kopiert',
  apiKeyCopyError: 'Fehler beim Kopieren des API-Schlüssels',
  changingPublicKeyWillAffectApps: 'Das Ändern des öffentlichen Schlüssels wirkt sich auf alle anwendungen aus, die verwendet werden, Möchten Sie fortfahren?',
  apiKey: 'API-Schlüssel',
  goToApiDoc: 'Zum API-Dokument wechseln',
  publicKey: 'Öffentlicher Schlüssel',
  privateKey: 'Privater Schlüssel',
  generate: 'Generieren',
  reNewPublicKey: 'Erneuern des öffentlichen Schlüssels',
  deleteInfoField: 'Informationsfeld löschen',
  sureToDeleteInfoField: 'Möchten Sie dieses Informationsfeld wirklich löschen?',
  addInfoOfPeopleOfBrand: 'Zusätzliche Informationen zu Ihren Markenmitarbeitern',
  sectionAddInfoPeopleOfBrandRequested: 'In diesem Abschnitt können Sie zusätzliche Informationen hinzufügen, die von Personen Ihrer Marke angefordert werden.',
  onlyBeSeenByAppAdministrator: 'Kann nur durch den Anwendungsadministrator gesehen werden',
  canBeSeenByPeople: 'Kann von Personen aus ihrem Profil gesehen und geändert werden',
  shortTextField: 'Kurzes Textfeld',
  dropDownList: 'Drop-Down-Liste',
  addNewInfoField: 'Hinzufügen eines neuen Informationsfelds',
  enterExtraDataId: 'Geben Sie den Extradata-Bezeichner ein.',
  epayCoCredentials: 'Epayco-Anmeldeinformationen',
  emailVerifyCredentials: 'E-Mail-Liste Überprüfen von Anmeldeinformationen',
  testEnvironment: 'Testumgebung',
  update: 'aktualisieren',
  modifyAddInfoField: 'Ändern des zusätzlichen Informationsfelds',
  createAddInfoField: 'Erstellen eines zusätzlichen Informationsfelds',
  fieldSuccessfullyDeleted: 'Das Feld wurde erfolgreich gelöscht.',
  fieldName: 'Feldname',
  access: 'Zugriff',
  addOptions: 'Hinzufügen von Optionen',
  option: 'Option | Optionen',
  fieldSuccessfullyCreated: 'Feld wurde erfolgreich erstellt',
  fieldSuccessfullyUpdated: 'Feld wurde erfolgreich aktualisiert',
  application: 'Bewerbung | Anwendungen',
  addAdministrator: 'Administrator hinzufügen',
  administratorsPerPage: 'Administratoren pro Seite',
  yes: 'Ja',
  no: 'Nein',
  loadingAdministrators: 'Laden von Administratoren',
  noAdministratorsRegistered: 'Keine registrierten Administratoren',
  action: 'Aktion | Aktionen',
  publicKeyUpdated: 'Öffentlicher Schlüssel wurde aktualisiert',
  editAdministrator: 'Administrator bearbeiten',
  newAdministrator: 'Neuer Administrator',
  selectAdministratorType: 'Auswählen des Administratortyps',
  wantAdministratorInactive: 'Soll der Administrator inaktiv sein?',
  selectAdministratorPermissions: 'Wählen Sie die Administratorberechtigungen aus',
  addNewAdministrator: 'Hinzufügen eines neuen Administrators',
  administratorSuccessfullyCreated: 'Administrator erfolgreich erstellt',
  administratorSuccessfullyUpdate: 'Administrator erfolgreich aktualisiert',
  wantToDeleteAdministrator: 'Möchten Sie diesen Administrator löschen?',
  deleteAdministrator: 'Administrator löschen',
  administratorSuccessfullyDeleted: 'Administrator wurde erfolgreich gelöscht',
  successfullyColorUpdated: 'Farbe erfolgreich aktualisiert',
  creditCard: 'Kreditkarte',
  inviteFinancier: 'Einladen Financier | Laden Sie den Finanzier ein',
  billing: 'Abrechnung',
  addCreditCard: 'Hinzufügen von Kreditkarte',
  loadBalance: 'Lastenausgleich',
  usage: 'Verwendung | Verwendung | Die Nutzung',
  payment: 'Zahlung | die Zahlung | Zahlungen | Die Zahlungen',
  paymentMethods: 'Zahlungsarten',
  completeBusinessDataBeforeAddingCreditCard: 'Füllen Sie Ihre Geschäftsdaten aus, bevor Sie eine Kreditkarte hinzufügen',
  lastDigits: 'Letzte Ziffern',
  cardExpirationDate: 'Ablaufdatum',
  changeToPrincipal: 'Wechseln zum Principal',
  creditCardSuccessfullyDeleted: 'Kreditkarte erfolgreich gelöscht',
  errorDeletingCreditCard: 'Beim Löschen der Karte ist ein Fehler aufgetreten.',
  creditCardPriorityUpdated: 'Kreditkartenpriorität aktualisiert',
  dailyUsage: 'Tägliche Nutzung',
  report: 'Bericht',
  recordsPerPage: 'Datensätze pro Seite',
  loadingRecords: 'Laden von Datensätzen',
  noMovementsRecords: 'Es gibt keine Bewegungsdatensätze',
  service: 'Service',
  amount: 'Menge',
  value: 'Wert',
  successfullyMovementsReportDownloaded: 'Bewegungsbericht wurde erfolgreich heruntergeladen',
  detailedConsumption: 'Detaillierter Verbrauch',
  approved: 'Genehmigt | Genehmigt',
  creditCardRechargeWithOutCharge: 'Aufladen der Kreditkarte ohne Gebühr',
  methodOf: 'Methode der',
  billCollection: 'Bill Collection',
  NoAdditionalInfoOfPayment: 'Ohne zusätzliche Zahlungsinformationen',
  noPaymentsRecords: 'Keine Zahlungsdatensätze',
  invoice: 'Rechnung',
  deposit: 'Einzahlung',
  makePayment: 'Bezahlen',
  warning: 'Warnung',
  rechargeToAvoidBlockingMainFunctions: 'Sie sollten Ihr Konto aufladen, um zu vermeiden, dass Ihre Hauptfunktionen blockiert werden',
  load: 'Laden',
  enterIdCardNumber: 'Geben Sie Ihre ID-Nummer ein',
  idCardNumber: 'ID-Nummer',
  createCard: 'Karte erstellen',
  youMustCompleteCardInformation: 'Sie müssen Ihre Kreditkartendaten ausfüllen',
  cardInformationIncorrect: 'Die Kartendetails sind falsch',
  creditCardSuccessfullyAdded: 'Kreditkarte erfolgreich hinzugefügt',
  checkCardDetails: 'Überprüfen Sie die Kartendetails',
  rejectedCard: 'Die Karte wurde abgelehnt',
  errorAddingCardPleaseTryAgain: 'Fehler beim Hinzufügen der Karte, Bitte versuchen Sie es erneut',
  noDependencies: 'Keine Abhängigkeiten',
  dependsOn: 'Hängt',
  loadingJourneys: 'Laden von Reisen',
  noJourneysForThisApp: 'Keine Fahrten für diese Anwendung',
  editJourney: 'Edit Journey',
  addNewJourney: 'Neue Reise hinzufügen',
  dependencies: 'Abhängigkeiten',
  selectJourneyColor: 'Wählen Sie die Reisefarbe',
  chooseAColor: 'Wählen Sie eine Farbe',
  wantThisDefaultStateWhenSomeoneSignsUp: 'Soll dies der Standardzustand sein, wenn sich jemand anmeldet?',
  wantToShowThisStateOnTheSideMenu: 'Möchten Sie diesen Status im Seitenmenü anzeigen?',
  loadingJourney: 'Laden Journey',
  addJourney: 'Journey hinzufügen',
  journeySuccessfullyCreated: 'Reise erfolgreich geschaffen',
  journeySuccessfullyEdited: 'Reise erfolgreich bearbeitet',
  yellow: 'Gelb',
  orange: 'Orange',
  red: 'Rot',
  purple: 'Lila',
  darkBlue: 'Dunkelblau',
  lightBlue: 'Hellblau',
  green: 'Grün',
  wantToDeleteJourney: 'Möchten Sie diese Reise löschen?',
  deleteJourney: 'Löschen Journey',
  journeySuccessfullyDeleted: 'Reise erfolgreich gelöscht',
  clickToSearchOnTheComputer: ', oder klicken Sie hier, um Dateien auf Ihrem Computer zu durchsuchen',
  lastName: 'Nachname',
  logInWith: 'Login mit',
  signInWith: 'Melden Sie sich mit',
  logInToYourAccount: 'Login in Ihr Konto',
  signIn: 'Anmelden',
  selectColor: 'Farbe auswählen',
  selectLogo: 'Logo auswählen',
  customPhrase: 'Benutzerdefinierte Phrase',
  customPhraseOnLogIn: 'Benutzerdefinierte Phrase beim Login',
  customPhraseOnSignIn: 'Benutzerdefinierte Phrase beim Anmelden',
  enterSignInMode: 'Geben Sie den Anmeldemodus ein',
  customPhraseOnLogInButton: 'Benutzerdefinierte Phrase auf Login-Taste',
  customPhraseOnSignInButton: 'Benutzerdefinierte Phrase beim Anmelden',
  hideSocialNetworks: 'Soziale Netzwerke ausblenden',
  showSignInFirst: 'Vorzeichen zuerst anzeigen',
  showCustomButton: 'Benutzerdefinierte Schaltfläche anzeigen',
  buttonText: 'Button-Text',
  requestData: 'Anforderungsdaten',
  defaultData: 'Standarddaten',
  identification: 'Identifizierung',
  department: 'Abteilung',
  healthProvider: 'Gesundheitsdienstleister',
  bloodType: 'Blutgruppe',
  day: 'Tag | Tage',
  month: 'Monat | Monate',
  allTheData: 'Alle Daten',
  year: 'Jahr | Jahre',
  range: 'Bereich',
  insertTheHtmlTemplateInTheFollowingField: 'Einfügen der HTML-Vorlage in das folgende Feld',
  templatePreview: 'Vorlagenvorschau',
  solo: 'Solo',
  normal: 'Normalen',
  needToRefreshBeforeCreateForms: 'Sie müssen aktualisieren, bevor Sie Formulare erstellen.',
  createForm: 'Formular erstellen',
  formsPerPage: 'Formulare pro Seite',
  loadingForms: 'Laden von Formularen',
  noFormsRegistered: 'Es sind keine registrierten Formulare vorhanden.',
  formName: 'Formularname',
  insertFormOnWebSite: 'Formular auf Ihrer Website einfügen',
  personalization: 'Personalisierung',
  injectableCode: 'Injizierbarer Code',
  customYourFormAndInsertGeneratedCodeOnTheNextTab: 'Benutzerdefinierte Ihr Formular, und fügen Sie dann den generierten Code auf der folgenden Registerkarte ein.',
  style: 'Stil',
  responseMessageSent: 'Antwortnachricht gesendet',
  sendButton: 'Send-Taste',
  length: 'Länge',
  alignment: 'Ausrichtung',
  selectFormColor: 'Wählen Sie Ihre Formularfarbe',
  divWithKeybeFormsToInsertForm: 'Um ein Formular in Ihre Webseite einzufügen, müssen Sie ein DIV-Element mit der ID ',
  andThenAddTheNextScriptToTheFooter: 'Fügen Sie dann das folgende Skript in der Fußzeile Ihrer Website hinzu',
  left: 'Links',
  right: 'Rechts',
  center: 'Center',
  small: 'klein',
  large: 'Große',
  none: 'nichts',
  outlined: 'Umrissen',
  filled: 'Gefüllt',
  editForm: 'Bearbeiten des Formulars',
  registerForm: 'Registerformular',
  obligateLogIn: 'Obligate Login?',
  assignRoleWhenFormIsCompleted: 'Rolle zuweisen, wenn das Formular ausgefüllt ist?',
  setUpNotificationsEmailForm: 'Einrichten einer E-Mail, in der Sie Benachrichtigungen über eine Formularübermittlung erhalten',
  emailSubject: 'E-Mail-Betreff',
  sendEmailOnSubmit: 'Senden von E-Mails beim Empfang von Einsenden',
  sendSmsOnSubmit: 'SMS senden, wenn Sie ein Senden empfangen',
  fields: 'Felder',
  addField: 'Feld hinzufügen',
  needToSelectRegisterEmailOrPhone: 'Sie müssen die Registrierungs-E-Mail oder das Telefon auswählen',
  formSuccessfullyEdited: 'Formular wurde erfolgreich bearbeitet',
  fieldLength: 'Feldlänge',
  required: 'Erforderlich',
  minFiles: 'Mindestanzahl von Dateien',
  linkOfTermsAndConditions: 'Link zu Geschäftsbedingungen',
  dataHandlingLink: 'Datenverarbeitungsverbindung',
  verificationFields: 'Überprüfungsfelder',
  filesUpLoad: 'Datei-Upload',
  dataManagement: 'Datenmanagement',
  hide: 'Ausblenden',
  multipleOption: 'Multiple-Wahl',
  NoRestrictions: 'Keine Einschränkungen',
  fullRow: 'Volle Reihe',
  halfRow: 'Halbe Reihe',
  newForm: 'Neue Form',
  addNewForm: 'Neues Formular hinzufügen',
  formSuccessfullyCreated: 'Formular korrekt erstellt',
  files: 'Dateien',
  fileType: 'Dateityp',
  responses: 'Antworten',
  responsesPerPage: 'Antworten pro Seite',
  loadingResponses: 'Laden von Antworten',
  noResponsesYet: 'Sie haben noch keine Antwort erhalten',
  next: 'nächster',
  largeTextField: 'Großes Textfeld',
  registry: 'Registrierung',
  creatingANewApplicationIsVerySimpleJustFillInTheInformationWeRequestToGoToTheNextStep: 'Erstellen einer neuen Anwendung ist sehr einfach, füllen Sie einfach die Informationen, die wir bitten, um den nächsten Schritt zu gehen (Einrichten von sozialen Netzwerken)',
  applicationName: 'Anwendungsname',
  addNewApplication: 'Neue Anwendung erstellen',
  applicationSuccessfullyCreated: 'Die Anwendung wurde erfolgreich erstellt',
  saveNewBusiness: 'Neues Geschäft retten',
  thePageYouAreLookingForDoesNotExist: 'Die gesuchte Seite existiert nicht',
  darkTheme: 'Dunkles Thema',
  lightTheme: 'Lichtthema',
  sidebar: 'Seitenleiste',
  toolbar: 'Symbolleiste',
  money: 'Geld',
  timeZoneInformation: `
  Das Zuweisen Ihrer Zeitzone ist wichtig,
  damit die Ihnen zugewiesenen Aufgaben sowie die Erstellungs- und
  Aktualisierungsdaten der Daten korrekt angezeigt werden.
  `,
  profilePicUpdated: 'Profilbild aktualisiert'
}
